import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['form', 'reset', 'acciones', 'ver', 'maximizarFiltros', 'maximizarOrdenacion', 'dropdownOrdenacion']

  initialize () {
    this.resetTarget.style.display = 'none'
    this.verTarget.style.display = 'none'
    this.accionesTarget.style.display = 'none'
  }

  ver () {
    this.maximizarFiltrosTarget.checked = false
    this.verTarget.style.display = 'none'
  }

  reset () {
    this.formTarget.reset()
    this.informarEspera('Quitando filtros')
    this.enviarForm()
    this.resetTarget.style.display = 'none'
    this.accionesTarget.style.display = 'none'
  }

  avisarBuscando () {
    this.informarEspera('Buscando')
  }

  filtrar () {
    this.informarEspera('Filtrando lista')
    this.enviarForm()
  }

  filtrarConEspera () {
    this.informarEspera('Filtrando lista')
    clearTimeout(this.esperaTimeout)

      this.esperaTimeout = setTimeout(() => {
        this.enviarForm()
      }, 1000)
  }

  ordenar () {
    this.informarEspera('Ordenando lista')
    this.enviarForm()
    this.dropdownOrdenacionTarget.classList.remove('open')
  }

  informarEspera (texto) {
    document.querySelector('.mobile-body, .rnk-ProductComparer').dataset.loading = texto
  }

  enviarForm () {
    Rails.fire(this.formTarget, 'submit')
    this.resetTarget.style.display = ''
    this.verTarget.style.display = ''
    this.accionesTarget.style.display = ''
    this.maximizarOrdenacionTarget.checked = false
  }
}
